export const AVAILABLE_FONTS = [
  { id: 'Geist', name: 'Geist (Vercel / Ultra-Moderna y Minimalista)', family: "'Geist', sans-serif" },
  { id: 'Inter', name: 'Inter (Moderna y Limpia - Recomendada)', family: "'Inter', sans-serif" },
  { id: 'Poppins', name: 'Poppins (Geométrica y Redondeada)', family: "'Poppins', sans-serif" },
  { id: 'Montserrat', name: 'Montserrat (Elegante y Corporativa)', family: "'Montserrat', sans-serif" },
  { id: 'Plus Jakarta Sans', name: 'Plus Jakarta Sans (Moderna / Tech)', family: "'Plus Jakarta Sans', sans-serif" },
  { id: 'Roboto', name: 'Roboto (Google Clásica)', family: "'Roboto', sans-serif" },
  { id: 'Open Sans', name: 'Open Sans (Neohumanista / Neutra)', family: "'Open Sans', sans-serif" },
  { id: 'Lato', name: 'Lato (Cálida y Amigable)', family: "'Lato', sans-serif" },
  { id: 'Playfair Display', name: 'Playfair Display (Serif Sofisticada)', family: "'Playfair Display', serif" },
  { id: 'Oswald', name: 'Oswald (Condensada / Gran Impacto)', family: "'Oswald', sans-serif" },
  { id: 'system', name: 'Sistema por Defecto (Segoe UI / Sans)', family: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif" }
];

export const FONT_SIZE_PRESETS = {
  title: [
    { id: 'small', label: 'Chico (1.35rem)', css: '1.35rem' },
    { id: 'medium', label: 'Mediano / Normal (1.75rem)', css: '1.75rem' },
    { id: 'large', label: 'Grande (2.25rem)', css: '2.25rem' },
    { id: 'xlarge', label: 'Extra Grande (2.85rem)', css: '2.85rem' }
  ],
  subtitle: [
    { id: 'small', label: 'Chico (0.85rem)', css: '0.85rem' },
    { id: 'medium', label: 'Mediano / Normal (1rem)', css: '1rem' },
    { id: 'large', label: 'Grande (1.18rem)', css: '1.18rem' }
  ],
  description: [
    { id: 'small', label: 'Chico (0.82rem)', css: '0.82rem' },
    { id: 'medium', label: 'Mediano / Normal (0.92rem)', css: '0.92rem' },
    { id: 'large', label: 'Grande (1.05rem)', css: '1.05rem' }
  ]
};

export const getFontFamilyCss = (fontId) => {
  if (!fontId || fontId === 'inherit' || fontId === 'default') return undefined;
  const match = AVAILABLE_FONTS.find(f => f.id.toLowerCase() === fontId.toLowerCase());
  return match ? match.family : fontId;
};

export const getTitleFontSizeCss = (sizeId) => {
  switch (sizeId) {
    case 'small': return '1.35rem';
    case 'medium': return '1.75rem';
    case 'large': return '2.25rem';
    case 'xlarge': return '2.85rem';
    default: return undefined;
  }
};

export const getSubtitleFontSizeCss = (sizeId) => {
  switch (sizeId) {
    case 'small': return '0.85rem';
    case 'medium': return '1rem';
    case 'large': return '1.18rem';
    default: return undefined;
  }
};

export const getDescriptionFontSizeCss = (sizeId) => {
  switch (sizeId) {
    case 'small': return '0.82rem';
    case 'medium': return '0.92rem';
    case 'large': return '1.05rem';
    default: return undefined;
  }
};

